<template>
    <div class="dark-block tenant-page">
        <page-title>
            <span>租户管理</span>
        </page-title>
        <div class="margin-tb-20">
            <Card class="tree-card">
                <div class="condition-box">
                    <Button type="primary" icon="ios-add-circle-outline" class="icon-btn" @click="popCreateModal">新建租户</Button>
                    <Input suffix="ios-search" clearable placeholder="请输入租户名称/租户管理员" v-model="searchStr" @on-enter="handleSearch" @on-clear="handleSearch"></Input>
                </div>
                <div class="margin-tb-20 table-group">
                    <Table class="margin-tb-20 scrollbar table-list" :columns="columns" :data="tenantList">
                        <template slot-scope="{ row }" slot="isAble">
                            <Tag v-if="row.isAble" color="red">已禁用</Tag>
                            <Tag v-else color="green">启用</Tag>
                        </template>
                        <template slot-scope="{ row }" slot="action">
                            <div class="action-group">
                                <Tooltip content="重置密码" placement="top">
                                    <Icon type="ios-unlock-outline" size="20" class="theme-color cursor-point" @click="resetPwd(row)"></Icon>
                                </Tooltip>
                                <Tooltip content="编辑" placement="top">
                                    <Icon type="ios-create-outline" size="20" class="margin-lr-10 cursor-point theme-color"  @click="popEditModal(row)"></Icon>
                                </Tooltip>
                                <Tooltip v-if="row.isAble" content="启用" placement="top">
                                    <Icon type="ios-remove-circle-outline" class="theme-color cursor-point" size="20" style="transform: rotateZ(-45deg)" @click="isAbleTenant(row)"></Icon>
                                </Tooltip>
                                <Tooltip v-else content="禁用" placement="top">
                                    <Icon type="ios-checkmark-circle-outline" class="theme-color cursor-point" size="20" @click="isAbleTenant(row)"></Icon>
                                </Tooltip>
                            </div>
                        </template>
                    </Table>
                </div>
                <Page ref="selection" class="text-left page-group"  :current="pageNum" :page-size="pageSize" :total="recordTotal"
                      size="small" show-total show-elevator show-sizer
                      @on-change="getTenantList"
                      @on-page-size-change="changePageSize"/>
            </Card>
        </div>
        <Modal
            :title="currentTenant.id?'编辑租户':'新建租户'"
            v-model="tenantModal">
            <Form ref="tenantForm" :model="currentTenant"  autocomplete="off" :rules="tenantFormRule" label-position="left" :label-width="140">
                <FormItem label="租户名称" prop="corpName">
                    <Input v-model="currentTenant.corpName" placeholder="请输入租户名称"></Input>
                </FormItem>
                <FormItem label="租户管理员用户名" prop="loginName">
                    <Input v-model="currentTenant.loginName"  autocomplete="nope" :readonly="readOnly" @on-focus="readOnly = false" @on-blur="checkUser" placeholder="请输入租户管理员用户名"></Input>
                </FormItem>
                <FormItem label="租户管理员密码" prop="password" v-if="!currentTenant.id">
                    <Input v-model="currentTenant.password" :type="!pasWd ? 'password' : 'text'" autocomplete="new-password" :readonly="pasWd" @on-focus="pasWd = false" placeholder="请输入租户管理员密码"></Input>
                </FormItem>
                <FormItem label="应用权限设置" prop="ids">
                    <Select v-model="currentTenant.ids" multiple filterable class="auth-select" placeholder="请搜索选择应用">
                        <Option v-for="item in appList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div class="footer" slot="footer">
                <Button @click="handleCloseTenantModal">取消</Button>
                <Button type="primary" :loading="tenantSaveLoading" @click="handleSaveTenant">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import api from '../../common/api';
import common from '../../common/common';

export default {
    name: 'Index',
    data() {
        return {
            searchStr: '',
            pageNum: 1,
            totalPage: 0,
            recordTotal: 0,
            pageSize: 20,
            tenantList: [],
            readOnly: true,
            pasWd: true,
            loginUserInfo: {},
            columns: [
                {
                    title: '租户名称',
                    key: 'corpName'
                }, {
                    title: '租户管理员',
                    key: 'loginName'
                }, {
                    title: '状态',
                    slot: 'isAble'
                }, {
                    title: '创建时间',
                    key: 'createTime'
                }, {
                    title: '操作',
                    slot: 'action',
                }
            ],
            currentRow: {},
            currentTenant: {},
            tenantFormRule: {
                corpName: [
                    { required: true, message: '请输入租户名称', trigger: 'blur' }
                ],
                loginName: [
                    { required: true, message: '请输入租户管理员用户名', trigger: 'blur' },
                    {
                        pattern: /^[0-9a-zA-Z_]{1,114}$/,
                        message: '账号长度1-114位字母或数字',
                        trigger: 'blur',
                    }
                ],
                password: [
                    { required: true, message: '请输入租户管理员密码', trigger: 'blur' }
                ]
            },
            tenantModal: false,
            tenantSaveLoading: false,
            appList: []
        }
    },
    created() {
        this.getTenantList();
        this.getAppList();
        this.loginUserInfo = common.getLoginUserInfo();
    },
    methods: {
        getAppList() {
            const param = {
                condition: '',
                pageNum: 1,
                pageSize: 0,
            }
            api.getAppList(param).then((res) => {
                if (res.resultCode === 0 && res.data.data && res.data.data.length) {
                    this.appList = res.data.data;
                }
            })
        },
        removeAttr() {
            this.removeAttribute('readonly')
        },
        checkUser() {
            if (!this.currentTenant.loginName) {
                return
            }
            api.checkUserExit({
                loginName: this.loginUserInfo.loginName,
                master: this.loginUserInfo.isMaster,
                tenantId: this.loginUserInfo.userId,
                userName: this.currentTenant.loginName
            }).then((res) => {
                if (res.data && res.data.messageType !== '0') {
                    this.$Message.warning(res.data.message)
                }
            })
        },
        getTenantList(val) {
            this.pageNum = val || 1;
            api.getTenantList({
                condition: this.searchStr,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then((res) => {
                console.log(res)
                if (res.resultCode === 0 && res.data && res.data.data) {
                    this.tenantList = res.data.data;
                    this.totalPage = res.data.pageTotal;
                    this.recordTotal = res.data.recordTotal;
                } else {
                    this.$Message.warning(res.resultMessage || '获取数据失败');
                }
            }).catch((e) => {
                console.log(e)
                this.$Message.warning(e.resultMessage || '获取数据异常');
            })
        },
        changePageSize(val) {
            this.pageNum = 1;
            this.pageSize = val;
            this.getTenantList()
        },
        handleSearch() {
            this.pageNum = 1;
            this.getTenantList();
        },
        resetPwd(row) {
            this.$Modal.confirm({
                title: '提示',
                loading: true,
                content: `<div>您确定要对 ${row.corpName} 重置密码吗？</div>`,
                onOk: () => {
                    api.resetPwd({
                        id: row.userId
                    }).then((res) => {
                        if (res.resultCode === 0) {
                            this.$Message.success('重置密码成功');
                            this.$Modal.remove()
                        } else {
                            this.$Message.warning(res.resultMessage || '重置密码失败');
                        }
                    }).catch((e) => {
                        console.log(e)
                        this.$Message.error(e.resultMessage || '操作异常');
                    })
                }
            });
        },
        popCreateModal() {
            this.currentTenant = {};
            this.tenantModal = true;
        },
        popEditModal(row) {
            api.getTenant(row.id).then((res) => {
                if (res.resultCode === 0 && res.data) {
                    this.currentTenant = JSON.parse(JSON.stringify(res.data));
                    this.currentRow = row;
                    this.tenantModal = true;
                } else {
                    this.$Message.warning(res.resultMessage || '获取租户详情失败');
                }
            }).catch((e) => {
                console.log(e)
                this.$Message.error(e.resultMessage || '获取租户详情异常');
            })
        },
        handleCloseTenantModal() {
            this.tenantModal = false;
        },
        handleSaveTenant() {
            this.$refs.tenantForm.validate((valid) => {
                if (valid) {
                    this.tenantSaveLoading = true;
                    if (!this.currentTenant.id) {
                        const params = {
                            ...this.currentTenant,
                        };
                        api.addTenant(params).then((res) => {
                            if (res.resultCode === 0) {
                                this.$Message.success('新增成功');
                                this.tenantModal = false;
                                this.getTenantList();
                            } else {
                                this.$Message.warning(res.resultMessage || '新增失败');
                            }
                            this.tenantSaveLoading = false;
                        }).catch((e) => {
                            this.$Message.error(e.resultMessage || '新增异常');
                            this.tenantSaveLoading = false;
                        })
                    } else {
                        const params = {
                            ...this.currentTenant,
                        };
                        api.editTenant(params).then((res) => {
                            if (res.resultCode === 0) {
                                this.$Message.success('编辑成功');
                                this.tenantModal = false;
                                Object.assign(this.currentRow, this.currentTenant);
                            } else {
                                this.$Message.warning(res.resultMessage || '编辑失败');
                            }
                            this.tenantSaveLoading = false;
                        }).catch((e) => {
                            this.$Message.error(e.resultMessage || '编辑异常');
                            this.tenantSaveLoading = false;
                        })
                    }
                }
            })
        },
        isAbleTenant(row) {
            const { id, isAble } = row;
            this.$Modal.confirm({
                title: '提示',
                loading: true,
                content: `<div>您确定要 ${isAble ? '启用' : '禁用'} ${row.corpName} 租户吗？</div>`,
                onOk: () => {
                    api.isAbleTenant({
                        id,
                        isAble: isAble ? 0 : -1
                    }).then((res) => {
                        if (res.resultCode === 0) {
                            this.$Message.success('操作成功');
                            row.isAble = isAble ? 0 : -1;
                        } else {
                            this.$Message.warning(res.resultMessage || '操作失败');
                        }
                        this.$Modal.remove();
                    }).catch((e) => {
                        this.$Message.error(e.resultMessage || '操作异常');
                        this.$Modal.remove();
                    })
                }
            });
        }
    }
}
</script>

<style scoped lang="less">
    .condition-box{
        display: flex;
        justify-content: space-between;
        .ivu-input-wrapper{
            width: 296px;
        }
    }
    /deep/ .ivu-table-with-fixed-top th{
        border-left: none!important;
    }
    .table-list {
        height: calc(100vh - 220px);
    }
    /*.action-group{*/
    /*    display: none;*/
    /*}*/
    /*.ivu-table-row:hover .action-group{*/
    /*    display: block;*/
    /*}*/
    /deep/ .auth-select{
        .ivu-select-dropdown{
            width: 100% !important;
            overflow-x: hidden !important;
        }
    }

</style>
